(() => {
  const selector = [
    '.product__description img',
    '.product-description-clean__content img',
    '#ProductDetails .rte img'
  ].join(',');

  function isShopifyImage(url) {
    return /(^|\.)cdn\.shopify\.com$/.test(url.hostname) || /(^|\.)shopifycdn\.com$/.test(url.hostname);
  }

  function optimizeImage(image) {
    if (image.dataset.blovoResponsive === 'true') return;
    image.dataset.blovoResponsive = 'true';

    if (!image.hasAttribute('loading')) image.loading = 'lazy';
    if (!image.hasAttribute('decoding')) image.decoding = 'async';
    if (!image.hasAttribute('fetchpriority')) image.setAttribute('fetchpriority', 'low');

    if (image.hasAttribute('srcset') || !image.currentSrc && !image.src) return;

    let source;
    try {
      source = new URL(image.getAttribute('src') || image.currentSrc, window.location.href);
    } catch (_error) {
      return;
    }
    if (!isShopifyImage(source)) return;

    const candidates = [360, 540, 750, 900, 1200, 1500];
    image.srcset = candidates.map((width) => {
      const candidate = new URL(source.href);
      candidate.searchParams.set('width', width);
      return candidate.href + ' ' + width + 'w';
    }).join(', ');
    if (!image.hasAttribute('sizes')) {
      image.sizes = '(min-width: 990px) 900px, calc(100vw - 3rem)';
    }
  }

  function optimize(root) {
    if (root.nodeType === 1 && root.matches && root.matches(selector)) optimizeImage(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(optimizeImage);
  }

  optimize(document);
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach(optimize));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();